import React, { useState, useEffect, useCallback } from 'react';
import {
  Table, Button, Typography, Select, Row, Col
} from 'antd';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import SubCategoryFormModal from './components/StoriesFormModal';
import SubCategoriesColumn from './components/StoriesColumn';
import EditSurgeryStory from './components/EditSurgeryStory';
import AdvancedSearchForm from '../../../common/SearchForm';
import moment from 'moment';

const { Title, Text } = Typography;
const { Option } = Select;

function CategoriesManagement(props) {

  const [searchOption, setSearchOption] = useState(false);
  const [infoModalVisible, setStoriesModalVisible] = useState(false);
  const [currentPage,setCurrentPage]=useState(1);

  const hideModal = () => {
    setStoriesModalVisible(false);
  };
  const onAddStories = async (payloadObj) => {
    hideModal();
    await props.addAtmedCatalogAbroadStories(payloadObj);
    await props.getAllCatalogAbroadStories(undefined,20,currentPage);
  };
  const onUpdateStories = async (payloadObj) => {
    await props.updateAtmedCatalogAbroadStories(payloadObj);
    await props.getAllCatalogAbroadStories(undefined,20,currentPage);
  };
  const onDeleteStories = async (payloadObj) => {
    await props.deleteAtmedCatalogAbroadStories(payloadObj);
    await props.getAllCatalogAbroadStories(undefined,20,currentPage);
  };

  const onStoriesSubmit = async (data) => {
    await onAddStories({ abroad_story: { ...data } });
    hideModal();
  };

  const renderData = useCallback((currentPage) => {
    props.getAllCatalogAbroadStories(undefined,20,currentPage);
  }, [props.getAllCatalogAbroadStories, props.updateAbroadStory, props.addAbroadStory, props.addAbroadStoryContent, props.deleteAbroadStory, props.deleteAbroadStoryContent])

  useEffect(() => {
    renderData(currentPage);
  }, [renderData,currentPage]);

  const columns = [
    {
      title: 'Story Name',
      key: 'pic_url',
      dataIndex: 'pic_url',
      render: (_, columnData) => (
        <>
          <Row className="name-details-row">
            <Col span={6}>
            </Col>
            <Col span={20}>
              <Text>
                <div>{columnData.title}</div>
              </Text>
              {columnData.status ? (
                <span className="activate">Active</span>
              ) : (
                <span className="inActivateNotverified">Blocked</span>
              )}
            </Col>
          </Row>
        </>
      ),
    },
    {
      title: 'Media',
      key: 'subCategory',
      width: '40%',
      render: (_, columnData) => (
        <SubCategoriesColumn
          columnData={columnData}
          updateStories={onUpdateStories}
          deleteStories={onDeleteStories}
        />
      ),
    },
    {
      title: 'CREATED',
      key: 'status',
      dataIndex: 'status',
      className: 'date-time',
      render: (_, columnData) => (
        <>
          <p>{moment(columnData.created_at).format('MM/DD/YYYY')}</p>
          <p>{moment(columnData.created_at).format('hh:mm A')}</p>
        </>
      )
    },
    {
      title: 'EDIT',
      key: 'actions',
      render: (_, columnData) => (
        <EditSurgeryStory deleteStories={onDeleteStories} updateStories={onUpdateStories} columnData={columnData} />
      ),
    },
  ];
  const onSearch = (values) => {
    const newValues = JSON.parse(JSON.stringify(values));
    const queryString = Object.keys(newValues)
      .map((key) => `${key}=${newValues[key]}`)
      .join('&');
    props.getAllCatalogAbroadStories(queryString,20,currentPage);
  };
  const toggleSearch = () => {
    setSearchOption(!searchOption)
  }

  return (
    <div>
      <SubCategoryFormModal
        onSubmit={onStoriesSubmit}
        onCancel={hideModal}
        visible={infoModalVisible}
        title={`Add Surgery Stories`}
        submitText="Add Stories"
      />
      <Row
        gutter={[0, 16]}
      >
        <Col className="gutter-row section-heading" span={12} offset={0}>
          <Title
            level={2}
            className="d-flex"
            style={{ justifyContent: 'space-between', alignItems: 'center' }}
          >
            Abroad Home Stories
          </Title>
        </Col>
        <Col className="gutter-row" span={5} offset={0}>
        </Col>
        <Col className="gutter-row header-buttons" span={3} offset={0}>
          <Button className={`${searchOption === true ? 'search-open' : 'search-close'} search-toggle-button`} onClick={() => toggleSearch()}>
            <SearchOutlined /> Search
          </Button>
        </Col>
        <Col className="gutter-row header-buttons" span={4} offset={0}>
          <Button onClick={() => { setStoriesModalVisible(true) }} icon={<PlusOutlined />} type="primary">
            <span style={{ fontWeight: '600' }}>
              Add Story
            </span>
          </Button>
        </Col>
      </Row>

      {searchOption === true ?
        <AdvancedSearchForm
          onSearch={onSearch}
          onClose={() => setSearchOption(false)}
          title="Health Products"
          formItems={[
            {
              key: 'q[title_cont]',
              label: 'Story Title',
            },
            {
              key: 'q[status_eq]',
              label: 'Status',
              Component: (
                <Select placeholder="Status - Active / Blocked" size="large">
                  <Option value>Active</Option>
                  <Option value={false}>Blocked</Option>
                </Select>
              ),
            },
          ]}
        /> : ''}
      <Table 
      className="list_table"       
       dataSource={props.allAbroadStory?props.allAbroadStory.data:null} 
        pagination={{ pageSize: 20, total: props.allAbroadStory?.total_count, showSizeChanger:false }} 
       columns={columns}
        scroll={{ x: 800 }}
        onChange={(e)=>{
          setCurrentPage(e.current);
        }}
        />
    </div>
  );
}

export default CategoriesManagement;
